import { put, call, takeLatest } from "redux-saga/effects";
import axios from 'axios';

import API_ENDPOINTS from "@services/apiConfig";

/********** ACTION_TYPES **********/
export const actionTypes = {
  sendOtp: "otp/INITIATE_SEND_OTP",
  sendOtpFailed: "otp/SEND_OTP_FAILED",
  sendOtpFulfilled: "otp/SEND_OTP_FULFILLED",

  verifyOtp: "otp/INITIATE_VERIFY_OTP",
  verifyOtpFailed: "otp/VERIFY_OTP_FAILED",
  verifyOtpFulfilled: "otp/VERIFY_OTP_FULFILLED",

  resetOtpState: "otp/RESET_STATE",
};

/********** REDUCER **********/
const initialState = {
  fetching: false,
  fetched: false,
  data: null,
  errMsg: null,
  verify: {
    fetching: false,
    fetched: false,
    data: null,
    errMsg: null
  },
  reset: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.sendOtp: {
      return { ...state, fetching: true };
    }
    case actionTypes.sendOtpFailed: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        errMsg: action.payload,
      };
    }
    case actionTypes.sendOtpFulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload,
        errMsg: null,
      };
    }
    case actionTypes.verifyOtp: {
      return { 
        ...state,
        verify:{
          ...state.verify,
          fetching: true
        } 
      };
    }
    case actionTypes.verifyOtpFailed: {
      return {
        ...state,
        verify: {
          ...state.verify,
          fetching: false,
          fetched: true,
          errMsg: action.payload,
      }
      };
    }
    case actionTypes.verifyOtpFulfilled: {
      return {
        ...state,
        verify: {
          ...state.verify,
          fetching: false,
          fetched: true,
          data: action.payload,
          errMsg: null,
      }
      };
    }
    case actionTypes.resetOtpState: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export const selectors = {
  sendOtpErrMsg: (state) => state.partnerApp.otp.errMsg || '',
  verifyOtpErrMsg: (state) => state.partnerApp.otp.verify.errMsg || '',
  verifiedMsg: (state) => state.partnerApp.otp.verify.data || ''
};

/********** ACTION_CREATORS **********/
export const actions = {
  sendOtp: (data) => ({
    type: actionTypes.sendOtp,
    payload: data,
  }),
  sendOtpFailed: (data) => ({
    type: actionTypes.sendOtpFailed,
    payload: data,
  }),
  sendOtpFulfilled: (data) => ({
    type: actionTypes.sendOtpFulfilled,
    payload: data,
  }),
  verifyOtp: (data) => ({
    type: actionTypes.verifyOtp,
    payload: data,
  }),
  verifyOtpFailed: (data) => ({
    type: actionTypes.verifyOtpFailed,
    payload: data,
  }),
  verifyOtpFulfilled: (data) => ({
    type: actionTypes.verifyOtpFulfilled,
    payload: data,
  }),
  resetOtpState: () => ({ 
    type: actionTypes.resetOtpState
  })
};

/********** WORKERS **********/
function* sendOtpWorker(action) {
  const { invoiceNumber } = action.payload;
  try {
    const response = yield call(
        [axios, 'post'],
        API_ENDPOINTS.SEND_OTP(invoiceNumber)
      )
    if (response.status == 200) {
      yield put(actions.sendOtpFulfilled(response.data));
    }
  } catch (err) {
    let errMsg = (err && err.response.data.error) || "Something went wrong";
    yield put(actions.sendOtpFailed(errMsg));
  }
}

function* verifyOtpWorker(action) {
  const { otp, invoiceNumber, source } = action.payload;
  try {
    const response = yield call(
        [axios, 'post'],
        API_ENDPOINTS.VERIFY_OTP(invoiceNumber),
        {
          otp,
          source
        }
    )
    if (response.status == 200) {
      yield put(actions.verifyOtpFulfilled(response.data.message));
    }
  } catch (err) {
    let errMsg = (err && err.response.data.error) || "Something went wrong";
    yield put(actions.verifyOtpFailed(errMsg));
  }
}


/********** SAGAS **********/
export function* saga() {
  yield takeLatest(actionTypes.sendOtp, sendOtpWorker);
  yield takeLatest(actionTypes.verifyOtp, verifyOtpWorker);
}